<template>
  <VueRecaptcha
    v-if="useV2 && siteKeyV2"
    ref="captcha"
    class="recaptcha"
    :sitekey="siteKeyV2"
    :load-recaptcha-script="true"
    @verify="executeV2"
    @expired="expired"
  />
</template>

<script>
import { defineComponent } from "vue";
import { load } from "recaptcha-v3";
import { VueRecaptcha } from "vue-recaptcha";

const url = new URLSearchParams(window.location.search);

export default defineComponent({
  name: "re-captcha",
  components: {
    VueRecaptcha,
  },
  data() {
    return {
      useV2: false,
      siteKeyV2: "",
      token: null,
      // v3
      recaptcha: null,
    };
  },
  methods: {
    async initV3(siteKey) {
      this.useV2 = false;
      this.recaptcha = await load(siteKey, { useEnterprise: true });
    },

    async initV2(siteKey) {
      this.siteKeyV2 = siteKey;
      this.useV2 = true;
    },

    async execute(action) {
      if (this.useV2) {
        return Promise.resolve(this.token);
      }

      if (url.get("captcha_error") === "1") {
        return Promise.resolve("debug_token");
      }

      return this.recaptcha.execute(action);
    },

    getVersion() {
      return this.useV2 ? 2 : 3;
    },

    executeV2(token) {
      this.token = token;
    },

    expired() {
      this.token = null;
      this.$refs.captcha.reset();
    },
  },
});
</script>

<style lang="scss" scoped>
.recaptcha {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>
